import { format, parseISO } from "date-fns";
import { FileText } from "lucide-react";
import React, { useRef, useState } from "react";
import {
  createNewNotes,
  fetchProgressNoteBySessionId
} from "../../api/notes";
import { Card, CardContent } from "../../components/card";
import { mysqlDatetimeToJavascriptDatetime } from "../../utils/helpers";
import OnlineSessionProgressNoteModal from "./OnlineSessionProgressNoteModal";

function NotesTabPanel({ notes, therapy_id }) {
  const [currentNote, setCurrentNote] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const currentSessionId = useRef(null);

  const handleNoteClick = async (note) => {
    try {
      const detailResponse = await fetchProgressNoteBySessionId(
        note.session_id,
        therapy_id
      );

      console.log("detailResponse", detailResponse);
      setCurrentNote({
        ...detailResponse,
        created_at: note.start_time,
      });
      setModalOpen(() => {
        currentSessionId.current = note.session_id;
        return true
      }
    );
    } catch (error) {
      console.error(error);
    }
  };

  const handleNewNoteClick = async () => {
    const newNote = await createNewNotes(
      "therapy_id_placeholder",
      "new_note_id",
      "",
      ""
    );
    setCurrentNote(newNote);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setCurrentNote(null);
  };

  return (
    <>
      {/* Progress Note Detail Dialog */}
      {currentNote && (
        <OnlineSessionProgressNoteModal
          isOpen={modalOpen}
          onClose={handleClose}
          sessionDate={new Date().toDateString()}
          editable={true}
          currentSessionId={currentSessionId.current}
          data={currentNote}
        />
      )}

      <div className="space-y-4">
        {notes.map((note, i) => (
          <Card
            key={i}
            className="cursor-pointer hover:shadow-md transition-shadow"
            onClick={() => {
              handleNoteClick(note);
            }}
          >
            <CardContent className="pt-6">
              <div className="flex items-center gap-2 mb-2">
                <FileText className="h-4 w-4 text-blue-500" />
                <span className="font-medium">
                  {format(
                    parseISO(
                      mysqlDatetimeToJavascriptDatetime(note.start_time) // Ensure this function exists
                    ),
                    "do MMM y"
                  )}
                </span>
              </div>
              <p className="text-gray-700 line-clamp-3">{note.summary}</p>
            </CardContent>
          </Card>
        ))}
        {notes.length <= 0 && "No Notes Available"}
      </div>
    </>
  );
}

export default NotesTabPanel;
